export default {
  badges: {
    ofpBadge: 'dt.designSystem.badges.ofpBadge',
    splashBadge: 'dt.designSystem.badges.splashBadge',
    guaranteedPlusBadge: 'dt.designSystem.badges.guaranteedPlusBadge',
    marketplaceBadge: 'dt.designSystem.badges.marketplaceBadge',
    rypBadge: 'dt.designSystem.badges.rypBadge',
  },
  components: {
    dialogBody: 'dt.designSystem.components.dialogBody',
    dialogCloseButton: 'dt.designSystem.components.dialogCloseButton',
    segmentedControl: {
      activeIndicator: 'dt.designSystem.components.segmentedControl.activeIndicator',
      link: 'dt.designSystem.components.segmentedControl.link',
    },
    multiSelectFilter: {
      trigger: 'dt.designSystem.components.multiSelectFilter.trigger',
      search: 'dt.designSystem.components.multiSelectFilter.search',
      option: 'dt.designSystem.components.multiSelectFilter.option',
      clear: 'dt.designSystem.components.multiSelectFilter.clear',
      apply: 'dt.designSystem.components.multiSelectFilter.apply',
    },
    filterPillsRow: {
      pill: 'dt.designSystem.components.filterPillsRow.pill',
      resultCount: 'dt.designSystem.components.filterPillsRow.resultCount',
    },
  },
};
